import React from "react";
import { Box, Chip, Collapse, Typography, useTheme, Select, MenuItem, FormControl, CircularProgress } from "@mui/material";
import { Check } from "@mui/icons-material";
import { Step, setSize, useSize } from "../../../state/map";
import { PaperSize } from "../types";
import { PaperInfo } from "../constants";
import { SectionTitle } from "./SectionTitle";
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import { StepProps } from "./types";
import { useAppDispatch } from "@/state/types";
import { usePriceFormatted, usePriceIsLoading, useCurrency, setCurrency } from "../../../state/image";
import { Currency } from "../../../types";

export const SizeStep = ({ expanded }: StepProps) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const size = useSize();
  const priceFormatted = usePriceFormatted();
  const priceIsLoading = usePriceIsLoading();
  const currency = useCurrency();

  const onSizeClick = (size: PaperSize) => {
    dispatch(setSize(size));
  }

  const sizeOptions = Object
    .values(PaperSize)
    .map((size) => ({
      label: PaperInfo[size].name,
      value: size,
    }));

  return (
    <>
      <SectionTitle
        icon={AspectRatioIcon}
        primary="Size"
        secondary="Choose your paper size"
        step={Step.Size}
      />
      <Collapse in={expanded} sx={{ pl: 2, py: 2, borderBottom: `${theme.palette.primary.dark} solid 2px` }} unmountOnExit>
        {/* Paper Size Selection */}
        <Box sx={{ mb: 3 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            {sizeOptions.map(({ value, label }) => (
              <Box
                key={value}
                onClick={() => onSizeClick(value)}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  p: 2,
                  borderRadius: 2,
                  border: '2px solid',
                  borderColor: size === value ? 'primary.main' : theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)',
                  bgcolor: size === value ? 'action.selected' : 'transparent',
                  cursor: 'pointer',
                  transition: 'all 0.2s',
                  '&:hover': {
                    borderColor: 'primary.main',
                    transform: 'translateX(4px)',
                  }
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Typography variant="body1" sx={{ fontWeight: 500 }}>
                    {label}
                  </Typography>
                  {value === PaperSize.A4 && (
                    <Chip 
                      label="Free" 
                      size="small" 
                      color="success"
                      sx={{ 
                        height: '20px', 
                        fontSize: '0.7rem', 
                        fontWeight: 600,
                        borderRadius: '4px'
                      }}
                    />
                  )}
                </Box>
                {size === value && (
                  <Check sx={{ color: 'primary.main' }} />
                )}
              </Box>
            ))}
          </Box>
        </Box>
      </Collapse>
    </>
  );
};

